import { Link } from '@tanstack/react-router';

import { Card } from '@/components/ui/card';

export function VerifyEmailPage() {
  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md items-center px-6">
      <Card className="w-full">
        <h1 className="text-2xl font-semibold">Email verified</h1>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
          You're all set. <Link to="/app" className="text-[var(--color-accent)] underline-offset-4 hover:underline">Go to your dashboard</Link>.
        </p>
      </Card>
    </div>
  );
}
